import { render, staticRenderFns } from "./Juntos.vue?vue&type=template&id=0f81f4cc&scoped=true&lang=pug&"
import script from "./Juntos.vue?vue&type=script&lang=js&"
export * from "./Juntos.vue?vue&type=script&lang=js&"
import style0 from "./Juntos.styl?vue&type=style&index=0&id=0f81f4cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81f4cc",
  null
  
)

export default component.exports